import {
  DESKTOP_LARGE_MIN_WIDTH,
  DESKTOP_SMALL_MIN_WIDTH,
  DESKTOP_X_LARGE_MIN_WIDTH,
  DESKTOP_XX_LARGE_MIN_WIDTH,
  TABLET_HORIZONTAL_MIN_WIDTH,
  TABLET_VERTICAL_MIN_WIDTH,
} from '@/constants/breakpoints';

// one direction only: every entry is open-ended, so a rule holds for its width and everything
// wider, and a layout is built by adding to the previous step instead of restating it. mixing in
// range queries is what makes breakpoints drift, so there are none. the strings carry no `@media`
// prefix, which lets the same value drive a styled block and a `window.matchMedia` call
export const breakPoints = {
  tabletVerticalUp: `screen and (min-width: ${TABLET_VERTICAL_MIN_WIDTH}px)`,
  tabletHorizontalUp: `screen and (min-width: ${TABLET_HORIZONTAL_MIN_WIDTH}px)`,
  desktopSmallUp: `screen and (min-width: ${DESKTOP_SMALL_MIN_WIDTH}px)`,
  desktopLargeUp: `screen and (min-width: ${DESKTOP_LARGE_MIN_WIDTH}px)`,
  desktopXLargeUp: `screen and (min-width: ${DESKTOP_X_LARGE_MIN_WIDTH}px)`,
  desktopXXLargeUp: `screen and (min-width: ${DESKTOP_XX_LARGE_MIN_WIDTH}px)`,
};
